module.exports = "/_next/static/images/IanDickey-b26c2f56270da08d685a0f8cce794c94.webp";